import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { initialFiscalPeriodsState } from "./FiscalPeriods.types";
import { FiscalPeriodsActions } from ".";
import {
  CLEAR_FISCAL_PERIODS_STATE,
  FETCH_FISCAL_PERIODS_FAILED,
  FETCH_FISCAL_PERIODS_LIST_FAILED,
  FETCH_FISCAL_PERIODS_LIST_PROGRESS,
  FETCH_FISCAL_PERIODS_LIST_SUCCESS,
  FETCH_FISCAL_PERIODS_PROGRESS,
  FETCH_FISCAL_PERIODS_SUCCESS,
  FETCH_REOPEN_PREVIEW_PROGRESS,
  REOPEN_PREVIEW_SUCCESS,
  REOPEN_PREVIEW_FAILED,
  RECLOSE_RANGE_PROGRESS,
  RECLOSE_RANGE_SUCCESS,
  RECLOSE_RANGE_FAILED,
} from "./FiscalPeriodsActions";

export const fiscalPeriodsReducer = (
  state: IStoreState["accounting"]["fiscalPeriods"] = initialFiscalPeriodsState,
  action: FiscalPeriodsActions
) => {
  switch (action.type) {
    case FETCH_FISCAL_PERIODS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list = [];
        draftState.totalRecords = 0;
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_FISCAL_PERIODS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }

    case FETCH_FISCAL_PERIODS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list = [];
        draftState.totalRecords = 0;
        draftState.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_FISCAL_PERIODS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.data = initialFiscalPeriodsState.data;
        draftState.error = null;
        draftState.dataLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_FISCAL_PERIODS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.dataLoading = LoadState.Loaded;
        draftState.data = data;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_FISCAL_PERIODS_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.data = initialFiscalPeriodsState.data;
        draftState.dataLoading = LoadState.Failed;
        draftState.error = error;
      });
      return newState;
    }

    case FETCH_REOPEN_PREVIEW_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.reopenPreviewLoading = LoadState.InProgress;
      });
      return newState;
    }

    case REOPEN_PREVIEW_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.reopenPreviewLoading = LoadState.Loaded;
        draftState.reopenPreview = data;
      });
      return newState;
    }

    case REOPEN_PREVIEW_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.reopenPreviewLoading = LoadState.Failed;
      });
      return newState;
    }

    case RECLOSE_RANGE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.recloseProgressLoading = LoadState.InProgress;
      });
      return newState;
    }

    case RECLOSE_RANGE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recloseProgressLoading = LoadState.Loaded;
        draftState.recloseProgress = data;
      });
      return newState;
    }

    case RECLOSE_RANGE_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.recloseProgressLoading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_FISCAL_PERIODS_STATE: {
      return initialFiscalPeriodsState;
    }

    default:
      return state;
  }
};
